import React, { useState, useContext, useEffect } from "react";
import "./Receipt.css";
import Axios from "axios";
import AuthContext from "../../context/AuthContext";
import LanguageContext from "../../context/LanguageContext";
import { API_URL } from "../../components/api";
import { formatDateTime } from "../../../utils/dateFormat";
import logo from "./logo.png"; // Adjust the path based on your project structure
import "./receipts.css";

function Receipt(props) {
  let authTokens = JSON.parse(localStorage.getItem("authTokens"));
  const { user } = useContext(AuthContext);
  const { language, direction, t } = useContext(LanguageContext);
  let client_id = props.client_id;
  const [data, setData] = useState(props.data || {});

  useEffect(() => {
    let isMounted = true;

    if (props.data) {
      setData(props.data);
      return () => {
        isMounted = false;
      };
    }

    const getReceipt = async () => {
      try {
        const response = await Axios.get(
          `${API_URL}/inventory/receipt/details/`,
          {
            headers: {
              Authorization: `Bearer ${authTokens.access}`,
              "Content-Type": "application/json",
            },
            params: {
              username: user.username,
              client_id: client_id,
            },
          }
        );

        if (response.status === 200 && isMounted) {
          setData(response.data);
          console.log(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    getReceipt();

    return () => {
      isMounted = false;
    };
  }, [authTokens.access, client_id, props.data, user.username]);

  const formatReceiptDateTime = (value) => {
    const formatted = formatDateTime(value);

    if (language !== "ar") {
      return formatted;
    }

    return formatted
      .replace(/\bAM\b/, t("collection.receiptAm"))
      .replace(/\bPM\b/, t("collection.receiptPm"));
  };

  const handlePrint = () => {
    const printWindow = window.open("", "_blank");

    // Create the HTML content for the print window
    printWindow.document.write(`
      <html lang="${language}" dir="${direction}">
        <head>
          <meta charset="UTF-8">
          <title>${t("collection.receipt")}</title>
          <style>
            body { font-family: Arial, sans-serif; direction: ${direction}; text-align: ${direction === "rtl" ? "right" : "left"}; }
            .receipt { width: 80%; margin: auto; }
            .print-button { display: none; }
            .line { display: flex; justify-content: space-between; }
            p { margin: 0px 0; padding: 0; }
            .left { float: left; }
            .right { float: right; }
          </style>
        </head>
        <body>
          <h5 style="display: flex; align-items: center;">
            <div>
              <p>Omega Speed</p>
              <p>76842442</p>
              <p>${t("collection.receiptDate")} ${formatReceiptDateTime(new Date())}</p>
            </div>
            <img id="logo" src="${logo}" alt="Logo" style="height: 80px; margin-inline-start: 40px;" />
          </h5>
          <p>------------------------------------------</p>
          <h1 style="margin: 5px 0;">${direction === "rtl" ? "" : "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"}${t("collection.receipt")}</h1>
          <p>------------------------------------------</p>
          <div>${t("collection.receiptFullName")}&nbsp;&nbsp;${data.fullname_en}</div>
          <div class="line"><p class="left">${t("collection.receiptBalanceUsd")}</p><p class="right">${
            data.balance_record
          }</p></div>
          <div class="line"><p class="left">${t("collection.receiptPaidUsd")}</p><p class="right">${
            data.paid_amount_usd
          }</p></div>
          <div class="line"><p class="left">${t("collection.receiptPaidLbp")}</p><p class="right">${
            data.paid_amount_lbp
          }</p></div>
          <div class="line"><p class="left">${t("collection.receiptExchangeRate")}</p><p class="right">${
            data.exchange_rate
          }</p></div>
          <div class="line"><p class="left">${t("collection.receiptRemainingAmount")}</p><p class="right">${
            data.balance_usd
          }</p></div>
          <p>------------------------------------------</p>
          <div class="line"><p class="left">${t("collection.receiptDiscountUsd")}</p><p class="right">${
            data.discount_usd
          }</p></div>
          <div class="line"><p class="left">${t("collection.receiptDiscountLbp")}</p><p class="right">${
            data.discount_lbp
          }</p></div>
          <p>------------------------------------------</p>
          <p>${t("collection.receiptThankYou")}</p>
        </body>
      </html>
    `);

    printWindow.document.close();

    // Add an event listener to print the window once the logo image is fully loaded
    printWindow.document.getElementById("logo").onload = () => {
      printWindow.print();
      props.close();
      printWindow.onafterprint = () => {
        printWindow.close();
      };
    };
  };

  return (
    <div className="receipt" dir={direction}>
      <h1
        style={{
          alignItems: "center",
        }}
      >
        {t("collection.receipt")}
        <img
          src={logo}
          alt="Logo"
          style={{ height: "50px", marginLeft: "20px" }}
        />
      </h1>
      <p>{t("collection.receiptDate")} {formatReceiptDateTime(new Date())}</p>
      <p>{t("collection.receiptFullName")} {data.fullname_en}</p>
      <p>{t("collection.receiptBalanceUsd")} {data.balance_record}</p>
      <p>{t("collection.receiptPaidAmountUsd")} {data.paid_amount_usd}</p>
      <p>{t("collection.receiptPaidAmountLbp")} {data.paid_amount_lbp}</p>
      <p>{t("collection.receiptExchangeRate")} {data.exchange_rate}</p>
      <p>{t("collection.receiptRemaining")} {data.balance_usd}</p>

      <p>{t("collection.receiptDiscountUsd")} {data.discount_usd}</p>
      <p>{t("collection.receiptDiscountLbp")} {data.discount_lbp}</p>
      <p>{t("collection.receiptThankYou")}</p>
      <button className="print-button" onClick={handlePrint}>
        {t("collection.receiptPrintButton")}
      </button>
    </div>
  );
}

export default Receipt;
